import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9b506a0a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "contents" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("section", { id: "page_another_head" }, [
  /*#__PURE__*/_createElementVNode("h1", null, "プレスリリース校正ツール"),
  /*#__PURE__*/_createElementVNode("p", { class: "mt10" }, " 入力ミスや言葉の誤用がないか、わかりにくい表記が使われていないかなどをチェックします。 ")
], -1))
const _hoisted_3 = {
  key: 0,
  class: "error-message"
}
const _hoisted_4 = { id: "page_contents" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { id: "message" }, null, -1))
const _hoisted_6 = { class: "box_proofreading" }
const _hoisted_7 = { class: "box_proofreading_item" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "proofreading_title input_header" }, " 入力フォーム ", -1))
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = { class: "submit-button" }
const _hoisted_11 = { class: "box_proofreading_item" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "proofreading_title result_header" }, " チェック済み ", -1))
const _hoisted_13 = ["innerHTML"]
const _hoisted_14 = { class: "submit-button" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1))
const _hoisted_16 = {
  key: 2,
  class: "loading-wrapper"
}
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "/static/image/column3_bx_loader.gif",
  class: "loading",
  alt: "loading"
}, null, -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "校正中・・・", -1))
const _hoisted_19 = [
  _hoisted_17,
  _hoisted_18
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_modal_ai_proofreader_login = _resolveComponent("modal-ai-proofreader-login")!
  const _component_modal_ai_proofreader = _resolveComponent("modal-ai-proofreader")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("article", null, [
      (_ctx.errors !== null && Object.keys(_ctx.errors).length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.errors.messages, (message) => {
              return (_openBlock(), _createElementBlock("p", { key: message }, _toDisplayString(message), 1))
            }), 128))
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("section", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _hoisted_8,
            (_ctx.result.userContent.length === 0)
              ? _withDirectives((_openBlock(), _createElementBlock("textarea", {
                  key: 0,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.userContent) = $event)),
                  name: "proofreader_text",
                  class: "release_text input",
                  "data-placeholder": "ここにリリース原稿を入力し「校正チェック」をクリックしてください。"
                }, null, 512)), [
                  [_vModelText, _ctx.userContent]
                ])
              : (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  class: "release_text input result_scroll",
                  innerHTML: _ctx.result.userContent
                }, null, 8, _hoisted_9)),
            _createElementVNode("div", _hoisted_10, [
              (_ctx.result.userContent.length === 0)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    class: "check-tool-button",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.openConfirmationModal()))
                  }, " 校正チェックをする "))
                : (_openBlock(), _createElementBlock("button", {
                    key: 1,
                    class: "reset-form-button",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.resetForm()))
                  }, " フォームをリセットする "))
            ])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _hoisted_12,
            _createElementVNode("div", {
              class: "release_text result result_scroll",
              innerHTML: _ctx.result.fixedUserContent
            }, null, 8, _hoisted_13),
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("button", {
                class: "copy-button",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.copyText()))
              }, " 全文コピーする ")
            ])
          ])
        ]),
        _hoisted_15,
        (_ctx.isShowLoginModal)
          ? (_openBlock(), _createBlock(_component_modal_ai_proofreader_login, { key: 0 }))
          : _createCommentVNode("", true),
        (_ctx.isShowConfirmationModal)
          ? (_openBlock(), _createBlock(_component_modal_ai_proofreader, {
              key: 1,
              onClose: _cache[4] || (_cache[4] = ($event: any) => (_ctx.closeConfirmationModal())),
              onSubmit: _cache[5] || (_cache[5] = ($event: any) => (_ctx.createNewProofreader()))
            }))
          : _createCommentVNode("", true),
        (_ctx.loading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_16, _hoisted_19))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}